import React from 'react';
import { Flex } from 'antd';
import type { InventoryTooltipItem } from '../type';

type InventoryCellTooltipProps = {
  items?: InventoryTooltipItem[];
};

const InventoryCellTooltip: React.FC<InventoryCellTooltipProps> = ({
  items = [],
}) => {
  if (!items.length) return null;

  return (
    <div className='inventory-tooltip-content'>
      <Flex vertical gap={8}>
        {items.map((item, index) => {
          const hasValue = Boolean(item.value);

          return (
            <Flex
              key={`${item.label}-${index}`}
              justify='space-between'
              gap={16}
              className='inventory-tooltip-row'
            >
              <span className='inventory-tooltip-label'>{item.label}</span>
              {hasValue ? (
                <span className='inventory-tooltip-value'>{item.value}</span>
              ) : null}
            </Flex>
          );
        })}
      </Flex>
    </div>
  );
};

export default InventoryCellTooltip;
